<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <div class="left">
          <div class="title">
            <span class="name">{{title}}</span>
          </div>
        </div>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="selected">
        <span class="title">已选：</span>
        <div class="items">
          <span class="item" v-for="(s, i) in selected" :key="i">
            <span class="name">
              {{`${s.ftitle}/${s.stitle}${s.ttitle ? '/' : ''}${s.ttitle || ''}`}}
            </span>
            <img src="../assets/img/resources/delete.svg" alt="delete" class="del" @click="deleteSelect(s)">
          </span>
        </div>
      </div>
      <div class="container">
        <empty :msg="'暂无数据'" v-if="options.length === 0" />
        <div class="section">
          <div class="item" :class="{on: o.selected,un: !o.available, bak: o.selected && o.title == one.title}" v-for="(o, oi) in options" :key="oi" @click="chooseOne(o)">
            <div class="left">
              <span class="title">{{o.title}}{{o.available==false ? '(空间不足)' : o.title=='X1' ? '(剩余'+o.free_space+'MB)' : null}}</span>
            </div>
            <img v-show="o.available" src="@assets/img/common/rightward.svg" alt="right" class="right">
            <img v-show="!o.available" src="@assets/img/common/rightwardgrey.svg" alt="right" class="right">
          </div>
        </div>
        <div class="section">
          <div :class="{item: true, bak: t.selected}" v-for="(t, ti) in one.list" :key="ti" @click="openThree(t)">
            <div class="left">
              <img class="checker" :src="!t.selected?icons.checker:icons.checkerOn" alt="checker" @click.stop="selectTwo(t)">
              <span class="title" @click="openThree(t)">{{t.title}}</span>
            </div>
            <img v-if="t.list.length > 0" @click="openThree(t)" src="@assets/img/common/rightward.svg" alt="right" class="right">
          </div>
        </div>
        <!-- <div class="section">
          <div :class="{item: true, on: tr.selected}" v-for="(tr, tri) in two.list" :key="tri" @click="selectThree(two, tr)">
            <div class="left">
              <img class="checker" :src="!tr.selected?icons.checker:icons.checkerOn" alt="checker">
              <span class="title">{{tr.title}}</span>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footline">
        <div class="btn greenBtn" @click="confirmSelect()">
          确定
        </div>
        <div class="btn" @click="close()">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'resourceHandles',
  components: {
    empty
  },
  data() {
    return {
      show: false,
      icons: {
        checker: require('@assets/img/common/checker-round.svg'),
        checkerOn: require('@assets/img/common/checker-round-on.svg')
      },
      selected: [],
      title: '选择发布平台',
      options: [],
      publishId: null,
      one: {
        list: []
      }, // 当前选择的第一级
      two: {} // 当前选择的第二级
    }
  },
  methods: {
    resetData() {
      // 重置数据状态
      this.one = {}
      this.two = {}
      this.three = {}
      this.resetOptions()
      this.options = []
      this.selected = []
    },
    resetOptions() {
      // 重置已选数据的状态
      this.options.forEach((f) => {
        f.list.forEach((s) => {
          s.selected = false
          s.list.forEach((t) => {
            t.selected = false
          })

          // if (s.list[0]) {
          //   s.list[0].selected = true
          // }
        })
      })
    },
    close() {
      // 关闭弹窗
      this.resetData()

      this.show = false
    },
    open(info) {
      // 打开弹窗，调用方法获取数据，传入已选项
      this.publishId = info.publishId
      this.selected = info.selected
      this.options = info.list
      console.log('open', this.selected, this.options)
      this.asyncInitState()
      this.calculateSelects()
      this.show = true
    },
    chooseOne(o) {
      // 选择一级
      if(o.available){
        this.two = {}
        this.one = o
      }
      // if (o.list.length === 1 && o.list[0].list.length === 0) {
      //   o.list[0].selected = true
      // }
    },
    selectTwo(t) {
      // 选择二级
      // if (this.one.list.length === 1 && this.one.list[0].list.length === 0) return
      t.selected = !t.selected
      this.calculateSelects()
    },
    openThree(t) {
      // 打开二级，显示三级
      this.two = t
    },
    selectThree(t, tr) {
      // 选择三级
      t.list.forEach(i => i.selected = false)

      tr.selected = !tr.selected
      this.calculateSelects()
    },
    deleteSelect(t) {
      // 删除已选平台
      // this.selected.forEach((o, i) => {
      //   if (t.fid == o.fid) {
      //     if (t.sid == o.sid) {
      //       if (t.tid) {
      //         if (t.tid == o.tid) {
      //           this.selected.splice(i, 1)
      //         }
      //       } else {
      //         this.selected.splice(i, 1)
      //       }
      //     }
      //   }
      // })

      this.options.forEach(o => {
        if (o.id === t.fid) {
          o.list.forEach(two => {
            if (two.id === t.sid) {
              two.selected = false

              two.list.forEach(three => {
                if (three.id === t.tid) {
                  three.selected = false
                }
              })
            }
          })
        }            
      })

      this.calculateSelects()
    },
    asyncInitState() {
      // 打开时同步外部状态
      this.options.forEach((i) => {
        i.list.forEach((t) => {
          // 默认选中三级第一项
          if (t.list[0]) {
            t.list[0].selected = true
          }
        })

        this.selected.forEach((s) => {
          if (s.fid === i.id) {
            i.list.forEach((t) => {
              if (s.sid === t.id) {
                t.selected = true
                t.list.forEach((f) => {
                  if (s.tid === f.id) {
                    t.list[0].selected = false
                    f.selected = true
                  }
                })
              }
            })
          }
        })
      })
    },
    calculateSelects() {
      // 检查一选项
      this.selected = []

      this.$nextTick(() => {
        this.options.forEach((i) => {
          
          // if (i.list.length === 1 && i.list[0].list.length === 0) {
          //   this.selected.push({
          //     fid: i.id,
          //     ftitle: i.title,
          //     sid: i.list[0].id,
          //     stitle: i.list[0].title
          //   })
          // } else {
            const oneChoosed = i.list.filter(res => res.selected).length > 0
            this.$set(i, 'selected', oneChoosed)
            
            i.list.forEach((two) => {
              // i.selected = two.selected
              if (two.selected) {
                if (two.list.length === 0) {
                  this.selected.push({
                    fid: i.id,
                    ftitle: i.title,
                    sid: two.id,
                    stitle: two.title,
                    preview_url: i.preview_url || ''
                  })
                } else {
                  two.list.forEach((three) => {
                    if (three.selected) {
                      this.selected.push({
                        fid: i.id,
                        ftitle: i.title,
                        sid: two.id,
                        stitle: two.title,
                        tid: three.id,
                        ttitle: three.title,
                        preview_url: i.preview_url || ''
                      })
                    }
                  })
                }
              }
            }) 
          // }
        })

        console.log('selected', this.selected)
      })
    },
    confirmSelect() {
      // 确定选择
      this.$emit('getSelected', this.selected)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1111;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    min-height: 514px;
    max-height: calc(100vh - 200px);
    padding:6px 30px 0;
    display: flex;
    flex-direction: column;
    .headline {
      // height: 62px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 14px 0 0;
      // border-bottom: 1px solid #dcdcdc;
      .left {
        width: 552px;
        display: flex;
        align-items: center;
      }
      .title {
        width: 272px;
        color: @dark;
        font-size: 24px;
        display: flex;
        align-items: center;
        .count {
          font-size: 14px;
          width: 22px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          color: #fff;
          background-color: @sub;
          border-radius: 100%;
          margin-right: 6px;
        }
        .seprate {
          margin: 0 4px;
        }
        .name {
          flex: 1;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }
      }
      .selectInputer {
        width: 280px;
        height: 40px;
        border-radius: 100px;
        background:rgba(185, 195, 195, 0.20);
        margin-left: 20px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        .enter {
          flex: 1;
          color: @dark;
          font-size: 14px;
          background-color: transparent;
          &::placeholder {
            color: @dateColor;
            font-size: 14px;
          }
        }
        .search {
          cursor: pointer;
          margin-right: 10px;
        }
      }
      .close {
        cursor: pointer;
      }
    }
    .selected {
      height: auto;
      display: flex;
      align-items: flex-start;
      min-height: 70px;
      padding: 20px 0;
      border-bottom: 1px solid #dcdcdc;
      overflow: hidden;
      &:hover {
        overflow-y: auto;
      }
      &::-webkit-scrollbar {
          width: 4px;
          height: 0;
      }
      &::-webkit-scrollbar-thumb {
        // background: rgba(5, 15, 15, 0.6);
        background: #B9C3C3;
        border-radius: 4px;
      }
      .title {
        font-size: 14px;
        color: @sub;
        margin-right: 10px;
        height: 30px;
        line-height: 30px;
      }
      .items {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -10px;
        .item {
          background-color: rgba(185, 195, 195, 0.2);
          border-radius: 4px;
          min-width: 76px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          color: @dark;
          font-size: 14px;
          margin-right: 16px;
          margin-bottom: 10px;
          .del {
            margin-left: 6px;
            cursor: pointer;
          }
        }
        .add {
          height: 30px;
          font-size: 13px;
          color: @sub;
          display: flex;
          align-items: center;
          .enter {
            margin-left: 10px;
            width: 120px;
            height: 30px;
            border-radius: 4px;
            background-color: rgba(185, 195, 195, 0.2);
            padding: 0 6px;
            display: flex;
            align-items: center;
            input {
              font-size: 14px;
              color: @dark;
              width: 100%;
              flex: 1;
              height: 100%;
              padding-right: 6px;
              background-color: transparent;
            }
            .cfm {
              cursor: pointer;
              flex-shrink: 0;
              color: @green;
            }
          }
        }
      }
    }
    .container {
      flex: 1;
      display: flex;
      justify-content: space-between;
      min-height: 296px;
      margin-top: 19.5px;
      .section {
        // width: 204px;
        width: 306px;
        min-height: 296px;
        background:rgba(185, 195, 195, 0.15);
        border-radius: 4px;
        overflow: hidden;
        &:hover {
          overflow-y: auto;
        }
        &::-webkit-scrollbar {
          width: 4px;
          height: 0;
        }
        &::-webkit-scrollbar-thumb {
          // background: rgba(5, 15, 15, 0.6);
          background: #B9C3C3;
          border-radius: 4px;
        }
        .item {
          padding: 0 12px;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: space-between;

           &.bak {
             background: rgba(185,195,195,0.15);
           }

           &.on {

             .left {

               .title {
                 color: @green;
                 font-weight: bold;
               }
             }
           }

           &.un {
             .left {
               .title {
                 color: #B4B4B4
               }
             }
           }
          cursor: pointer;
          .left {
            flex: 1;
            display: flex;
            align-items: center;
            .checker {
              margin-right: 16px;
            }
            .title {
              color: @sub;
              font-size: 13px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          &:hover {
            background-color: rgba(185, 195, 195, .15);
          }
        }
      }
    }
    .footline {
      min-height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        background-color: @dateColor;
        color: #fff;
        border-radius: 100px;
        cursor: pointer;
        &:active {
          .btnActive;
        }
        &:hover {
          .btnHover;
        }
      }
      .greenBtn {
        background-color: @green;
        margin-right: 20px;
      }
      .add {
        margin-right: 20px;
      }
      .right {
        height: 40px;
        width: 260px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
